export const BUILD_VERSION = '1787315640';
